import { render, staticRenderFns } from "./modalBox.vue?vue&type=template&id=73ea817a"
import script from "./modalBox.vue?vue&type=script&lang=js"
export * from "./modalBox.vue?vue&type=script&lang=js"
import style0 from "./modalBox.vue?vue&type=style&index=0&id=73ea817a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports